// extracted by mini-css-extract-plugin
export default {"successContent":"SuccessModal_successContent__8XfLP","successTitle":"SuccessModal_successTitle__MM31L","closeButton":"SuccessModal_closeButton__cjDpw"};